import React, { useCallback, useEffect, useState } from 'react'

import { Container, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ErrorBoundary } from '@scoir/error-reporter'

import api from 'common/api'
import useScid from 'common/use-scid'
import useTitle from 'common/use-title'

import ActivateMessaging from './components/ActivateMessaging'
import Banner from './components/Banner'
import ConfigurationComplete from './components/ConfigurationComplete'
import EnableAudienceInsights from './components/EnableAudienceInsights'
import EnableAudienceSharing from './components/EnableAudienceSharing'
import Loading from './components/Loading'

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(10),
    backgroundColor: 'white',
    display: 'flex',
    flexGrow: 1,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(5),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(10),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  content: {
    [theme.breakpoints.down('sm')]: {
      order: 2,
    },
  },
  banner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      order: 1,
    },
  },
}))

export const ConfigureIntegration = () => {
  useTitle('Integrations')

  const scid = useScid()
  const [config, setConfig] = useState(null)
  const getConfig = useCallback(() => {
    api
      .get(`/api/colleges/${scid}/integration/crm/configuration`)
      .then((response) => {
        setConfig(response)
      })
      .catch(() => '')
  }, [scid])
  useEffect(getConfig, [getConfig])

  const styles = useStyles()
  const loading = !config
  const isComplete = !loading && config.messagingActivated && config.matchingActivated && config.matchResultsActivated

  return (
    <Container
      className={styles.container}
      maxWidth={false}
    >
      <Container maxWidth="lg">
        <ErrorBoundary>
          <Loading isLoading={loading}>
            <Grid
              container
              spacing={10}
            >
              <Grid
                item
                sm={12}
                md={6}
                className={styles.content}
              >
                {isComplete ? (
                  <ConfigurationComplete config={config} />
                ) : (
                  <>
                    <ActivateMessaging config={config} />
                    <EnableAudienceSharing
                      config={config}
                      getConfig={getConfig}
                    />
                    <EnableAudienceInsights
                      config={config}
                      getConfig={getConfig}
                    />
                  </>
                )}
              </Grid>
              <Grid
                item
                sm={12}
                md={6}
                className={styles.banner}
              >
                <Banner config={config} />
              </Grid>
            </Grid>
          </Loading>
        </ErrorBoundary>
      </Container>
    </Container>
  )
}

export default ConfigureIntegration
